import { setSortByValueActon } from './../Filter/FilterVM';
import { action } from 'mobx';
import stores from 'cd-eft/models/Stores';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import * as PRJAPI from 'cd-eft/services/eftPrjAdminApi';
import SpatialReference from '@arcgis/core/geometry/SpatialReference';
import { getErrorFromAPIResponse } from 'cd-eft/utils/getError';

const libraryStore = stores.AppStore.projectsLibraryStore;
const surveyEnggStore = stores.AppStore.surveyEngineeringStore;

export class ProjectsLibraryVM {
  history: any;
  constructor(history) {
    this.history = history;
  }

  localStorageUsername: any = localStorage.getItem('username');

  @action.bound setCurrentPage(page) {
    libraryStore.pageNumber = page;
    this.history.push(`/projects/page/${page}`);
  }

  @action.bound clearFilterString() {
    libraryStore.filterString = '';
  }

  @action.bound clearFilterSortBy() {
    libraryStore.sortBy = 3;
    setSortByValueActon();
    libraryStore.sortBy = 0;
  }

  @action.bound clearFilterProjectType(id) {
    libraryStore.filterProjectTypes.delete(id);
    if (libraryStore.filterProjectTypes.size === 0) libraryStore.filterProjectStatuses = new Set();
  }

  @action.bound clearFilterProjectStatus(id) {
    libraryStore.filterProjectStatuses.delete(id);
  }
}

export const getSpatialRefByProject = async (projectId) => {
  MessageCenter.clearMessages();
  if (!projectId) return;
  try {
    libraryStore.projectProjectionInfo = '';
    const response = await PRJAPI.SpatialRefControllerApi.getSpatialRefByProjectUuidUsingGET(projectId)

    if (response.data) {
      libraryStore.projectSpatialRefData = response.data
      libraryStore.projectProjectionInfo = response.data.coordinateType ? (response.data.coordinateType + ' Zone ' + response.data.zone + ' ' + response.data.unit) : ''

      surveyEnggStore.isStatePlane = response.data.coordinateType=="NAD83(2011) StatePlane"?true:false;

      //For a given project, there will be either wkid or wktJson but not both of them
      if (response.data.wkid !== null) {
        libraryStore.projectSpatialReference = new SpatialReference({ wkid: Number(response.data.wkid) });
      } else if (response.data.wktJson !== null) {
        const wktString = response.data.wktJson;
        libraryStore.projectSpatialReference = new SpatialReference({ wkt: wktString });
      }
    }
  } catch (error) {
    getErrorFromAPIResponse(error)
  }
}

export const getStateNameByStateCode = async (state_code) => {
  MessageCenter.clearMessages();
  if (!state_code) {
    return;
  }
  try {
    const response = await PRJAPI.StateCountyController.getStateNameByStateCodeUsingGET(state_code);
    if (response.data) {
      const state_name = response.data[0].state_name
      return state_name
    }
  } catch (error) {
    MessageCenter.addError((error as Error).message);
  }
}

export const getXYByStateCounty = async (state_code, county) => {
  MessageCenter.clearMessages();
  if (!state_code || !county) {
    return;
  }

  try {
    const response = await PRJAPI.StateCountyController.getXYByStateCountyUsingGET(state_code, county);
    if (response.data) {
      libraryStore.xyByStateCounty = response.data as StateCountyResponse
    }
  } catch (error) {
    MessageCenter.addError((error as Error).message);
  }
}

export const getProjectionByLocation = async (coordinateSystemType, state, county, storeData = true) => {
  const isStatePlane = coordinateSystemType?.includes('StatePlane');

  await getXYByStateCounty(state, county)
  // Get the stateName for the respective state_code
  const stateName = await getStateNameByStateCode(state);

  const payload = {
    coordinateType: coordinateSystemType,
    ...(isStatePlane
      ? {
        state: stateName,
        centroidX: libraryStore.xyByStateCounty?.centroidx,
        centroidY: libraryStore.xyByStateCounty?.centroidy,
      }
      : {
        xmax: libraryStore.xyByStateCounty?.xmax,
        xmin: libraryStore.xyByStateCounty?.xmin,
        ymax: libraryStore.xyByStateCounty?.ymax,
        ymin: libraryStore.xyByStateCounty?.ymin,
      }),
  };

  // Check if all required values are available
  const isDataComplete = Object.values(payload).every(value => value !== undefined && value !== '');
  if (isDataComplete && state && county) {
    try {
      const response = await PRJAPI.ProjectionMetadataController.getProjectionByLocationUsingPOST(payload);
      if (response.data) {
        if (storeData) {
          libraryStore.pojectionByLocationData = response.data;
        }
        return response.data;
      }
    } catch (error) {
      MessageCenter.addError((error as Error).message);
    }
  }
}

interface StateCountyResponse {
  stateCode: string;
  countyName: string;
  xmin: number;
  xmax: number;
  ymin: number;
  ymax: number;
  centroidx: number;
  centroidy: number;
}